<template>
  <iframe
    :id="config.id"
    :class="$style.iframe"
    :src="config.src"
    @load="iframeLoaded"
    :style="{ height: config.height, 'min-width': config.width }"
  >
  </iframe>
</template>

<script>
import iFrameResize from "iframe-resizer/js/iframeResizer";

export default {
  name: "IFrameResizer",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    iframeLoaded() {
      this.$emit("loaded");
      iFrameResize(
        {
          scrolling: "omit",
          onInit: iframe => {
            iframe.scrolling = "no";
            iframe.style.minWidth = "100%";
            iframe.iFrameResizer.resize();
          }
        },
        "#" + this.config.id
      );
    }
  }
};
</script>

<style module lang="scss">
@import "./IFrameResizer.scss";
</style>
